import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { connect, useDispatch, useSelector } from "react-redux";
import ContentContainer from "../../common/ContentContainer";
import { useTranslation } from "react-i18next";
import { Col, Form, Row } from "react-bootstrap";
import { CREATE_BOT_START, SET_BOT_NAME } from "../../../actions/create-bot-type";
import BotTitle from "./modules/BotTitle";
import AssetParamSection from "./modules/AssetParamSection";
import EntryExitSection from "./modules/EntryExitSection";
import BackTestSection from "./modules/BackTestSection";
import { useHistory, useLocation } from "react-router-dom";
import IndicatorSetting from "./indicator-setting/IndicatorSetting";
import IndicatorSettingModal from "./indicator-setting/IndicatorSettingModal";
import CreateBotSection from "./modules/CreateBotSection";
import Loading from "../../common/Loading";
import AssetView from "./AssetView";
import GridBotParamsView from "./grid-bot/GridBotParamsView";
import TradeParamsView from "./TradeParamsView";
import { BotType } from "../../../Const";
import EntryView from "./modules/EntryView";
import ExitView from "./modules/ExitView";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const CreateBotSteps = (props)=>{
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const newBot = useSelector((state) => state.createBot.newBot);
    const isEditing  = newBot.isEditing;
    const [activeTab,setActiveTab] = useState(0);
    const stepTitles = ['Asset','Trade Parameters','Entry Conditions','Exit Conditions',isEditing?'Update Bot':'Create Bot'];
    const changeTab = (type)=>{
        window.scrollTo(0, 0);
        if(type=="next"){
            setActiveTab(activeTab+1)
        }
        if(type=="prev"){
            setActiveTab(activeTab-1)
        }
    }
    const steps = stepTitles.map((item,index)=>{
        return (
            <li key={index}>
                <a onClick={()=>{
                    if(activeTab === 0 && index !== 0 && !newBot.pair){
                        toast.warn(t("pls-select-stock-symbol"));
                        return;
                    }
                    window.scrollTo(0, 0);
                    setActiveTab(index>3?3:index)
                }} className={`pointer`}>
                    <label className={activeTab>=index||activeTab==3?'active':''}><img src={`/images/cb-step-${index}.svg`} alt=""/></label>
                    {item}
                </a>
            </li>
        )
    })
    const tabs = [
        <AssetView newBot={newBot} t={t} step={changeTab}/>,
        newBot.botType === BotType.grid ? (
            <GridBotParamsView editing={newBot.isEditing}
            newBot={newBot} t={t} step={changeTab}/>
          ) : (
            <TradeParamsView
            editing={newBot.isEditing}
            newBot={newBot}
            t={t}
            step={changeTab}
          />),
          <EntryView step={changeTab}></EntryView>,
          <ExitView step={changeTab}></ExitView>
        
    ];
    return(
        <>
            <div className={`bot-advance-asset-tab ba-tab${activeTab}`}>
            <Link to="/bots" className="cb-quit"><i className="fa-sharp-duotone fa-solid fa-xmark"></i></Link>
                <ul className="bc-step-icons">
                    {steps}
                </ul>
            </div>
            <div className="ba-asset-form-area ec-from">
                {tabs[activeTab]}
            </div>
        </>
      );
}

export default connect(null,{})(CreateBotSteps)